import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";

import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import ImageUploader from "../../components/upload-image";
import { FormikSwitch } from "../../components/switch";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, userImagesArray, handleUserImagesAdd, handleUserImagesDelete } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Footer</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
                    <div className="flex flex-col">
                      <Label label="Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="description" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="cta_label" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="CTA Redirection" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="cta_redirection" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikTextarea name="footer_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Social Icons</Accordion.Header>
                <Accordion.Body>
                  <div className="flex justify-end mt-3">
                    <div className=" bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer ">
                      <Plus onClick={handleUserImagesAdd} className={" text-[white]"} />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full table-fixed border-collapse border border-gray-300 text-sm">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="w-[31.33%] border font-normal border-gray-300 p-2 text-left">Social Url</th>
                          <th className="w-[31.33%] border font-normal border-gray-300 p-2 text-left">Social Logo</th>
                          <th className="w-[31.33%] border font-normal border-gray-300 p-2 text-left">Alt tag</th>
                          <th className="w-[6%] border font-normal border-gray-300 p-2 text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="social_media.medial_details"
                          render={(arrayHelper) => {
                            userImagesArray.current = arrayHelper;
                            return (
                              <>
                                {values?.social_media?.medial_details?.map((item, index) => (
                                  <tr key={index} className="align-top">
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`social_media.medial_details.${index}.social_url`} rootClassName="w-full" />
                                    </td>
                                    <td className="border px-2 py-2">
                                      <ImageUploader
                                        imgStyle={{ width: "8rem" }}
                                        title="image"
                                        imageUrl={values?.social_media?.medial_details?.[index]?.image_url}
                                        onChange={(res) => {
                                          setFieldValue(`social_media.medial_details.${index}.image_url`, res?.data?.file_url);
                                        }}
                                      />
                                    </td>
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`social_media.medial_details.${index}.alt_tag`} rootClassName="w-full" />
                                    </td>
                                    <td className="w-[6%] border px-2 py-2 text-center">
                                      <div className="flex justify-center cursor-pointer" onClick={handleUserImagesDelete(index)}>
                                        <Trash />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Quick Links</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="quick_links.heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <FieldArray
                    name="quick_links.inside_pages"
                    render={(arrayHelpers) => {
                      return (
                        <>
                          <div className="flex justify-end mt-3">
                            <div
                              className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer"
                              onClick={() =>
                                arrayHelpers.push({
                                  page_name: "",
                                  page_url: "",
                                })
                              }
                            >
                              <Plus className="text-white" />
                            </div>
                          </div>

                          {/* Table */}
                          <div className="mt-3 overflow-x-auto">
                            <table className="w-full table-fixed border-collapse border border-gray-300">
                              <thead className="bg-gray-200">
                                <tr>
                                  <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Page Name</th>
                                  <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Redirect Url</th>
                                  <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {values?.quick_links?.inside_pages?.map((item, index) => (
                                  <tr key={index}>
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`quick_links.inside_pages.${index}.page_name`} rootClassName="w-full" />
                                    </td>
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`quick_links.inside_pages.${index}.page_url`} rootClassName="w-full" />
                                    </td>
                                    <td className="w-[6%] border border-gray-300 px-4 py-2">
                                      <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                        <Trash />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      );
                    }}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Support & Help</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="support_and_help.heading" rootClassName="w-full" />
                    </div>
                  </div>

                  {/* FieldArray starts here */}
                  <FieldArray
                    name="support_and_help.inside_pages"
                    render={(arrayHelpers) => {
                      return (
                        <>
                          {/* ➕ Add Button */}
                          <div className="flex justify-end mt-3">
                            <div
                              className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer"
                              onClick={() =>
                                arrayHelpers.push({
                                  page_title: "",
                                  page_redirect_url: "",
                                })
                              }
                            >
                              <Plus className="text-white" />
                            </div>
                          </div>

                          {/* Table */}
                          <div className="mt-3 overflow-x-auto">
                            <table className="w-full table-fixed border-collapse border border-gray-300">
                              <thead className="bg-gray-200">
                                <tr>
                                  <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Page Name</th>
                                  <th className="w-[40%] border font-normal border-gray-300 px-2 py-2 text-left">Redirect Url</th>
                                  <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {values?.support_and_help?.inside_pages?.map((item, index) => (
                                  <tr key={index}>
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`support_and_help.inside_pages.${index}.page_title`} rootClassName="w-full" />
                                    </td>
                                    <td className="border px-2 py-2">
                                      <FormikInput name={`support_and_help.inside_pages.${index}.page_redirect_url`} rootClassName="w-full" />
                                    </td>
                                    <td className="w-[6%] border border-gray-300 px-4 py-2">
                                      <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                        <Trash />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      );
                    }}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Subscribe to our recipes</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="subscribe.title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="subscribe.description" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Skill India Marquee</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Prefix Text" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="skill_india_marquee.prefix_text" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Suffix Text" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="skill_india_marquee.suffix_text" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Logo" className="mb-2 text-black text-[15px] font-semibold" />
                      <ImageUploader
                        imgStyle={{ width: "8rem" }}
                        title="Logo"
                        imageUrl={values?.skill_india_marquee?.logo_url}
                        onChange={(res) => {
                          setFieldValue("skill_india_marquee.logo_url", res?.data?.file_url);
                        }}
                      />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Is Visible" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikSwitch name="skill_india_marquee.is_visible" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
